import { useCallback } from 'react';
import { client } from '@/apis/client';
import { ChatRoom } from '@/functions/types/chatRoom';

type Params = {
  id: number;
  body: {
    like_from: string;
  };
};

type Response = ChatRoom;

const api = (params: Params): Promise<Response> => {
  return client.post(`v1/users/${params.id}/talks`, params.body);
};

type Props = Params;

/**
 * メッセージ送信 or いいね!
 */

export const usePostIdTalks = () => {
  const postIdTalks = useCallback(async (props: Props) => {
    const res = await api(props);

    return res.id;
  }, []);

  return { postIdTalks };
};
